'use strict';

module.exports = {
    paypalExpress: function () {
        $('.paypal-cart-button').off('click.payPalCTA').on('click.payPalCTA', function (e) {
            e.preventDefault();
            var url = $('.paypal-cart-button').data('url');
            url += '?rdfuid=' + $('#RDFUID').val();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                success: function (data) {
                    if (data.redirectUrl) {
                       window.location.href = data.redirectUrl;
                    }
                }
            });
        });
    }
}